import type { CSS } from '@components-shared/src/stitches';
import { bubble } from '@components/animations/bubble';
import {
  slideDownAndFade,
  slideLeftAndFade,
  slideRightAndFade,
  slideUpAndFade,
} from '@components/animations/fade';

export const animationStyles: CSS = {
  '@media (prefers-reduced-motion: no-preference)': {
    animationDuration: '400ms',
    animationTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)',
    willChange: 'transform, opacity',
    '&[data-state="delayed-open"], &[data-state="open"], ': {
      '&[data-side="top"]': { animationName: slideDownAndFade },
      '&[data-side="right"]': { animationName: slideLeftAndFade },
      '&[data-side="bottom"]': { animationName: slideUpAndFade },
      '&[data-side="left"]': { animationName: slideRightAndFade },
    },
  },
};
export const contentStyles: CSS = {
  borderRadius: 8,
  height: '100%',
  padding: '8px 6px',
  backgroundColor: '$neutral900',
  boxShadow: '0px 0px 0px 1px rgba(0, 0, 0, 0.04), 0px 8px 28px rgba(0, 0, 0, 0.28)',
  base: 'XS',
  fontStyle: 'medium',
  color: '#fff',

  '.arrow': {
    fill: '#000',
    width: ' unset',
    height: 'unset',
  },

  ...animationStyles,
};

export const HOVER_VISIBLE_CSS: CSS = {
  opacity: 1,
  visibility: 'visible',
  animationDuration: '300ms',
  animationFillMode: 'forwards',
  animationName: `${bubble}`,
  animationTimingFunction: 'linear',
  transition: `${bubble} 300ms linear`,
};
